import React from "react";
import Skeleton from "../common/Skeleton";

const HeroSkeleton = () => {
  return <Skeleton height="60vh" width="100%" radius="0" />;
};

export default HeroSkeleton;
